export default "__VITE_ASSET__aTxFPuat__"